export default "__VITE_ASSET__VQUlaBLp__"